import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from "@coveord/plasma-mantine";
import { Locales } from "../../../strings/Locales";
export var DeleteBulkResourcesPromptCancelButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Prompt.CancelButton, {
        onClick: onClick,
        children: Locales.format("DeleteBulkResourcesPrompt.footer.button.cancel")
    });
};

//# sourceMappingURL=DeleteBulkResourcesPromptCancelButton.js.map